import { FileUp } from "lucide-react"
import type { NotificationRenderer } from "../../types"
import { navigateForAction } from "../actionRoutes"

// Icon mirrors the sidebar's questionnaire entry (AppSidebarV2 ICONS.upload)
// so the notification is recognizable as belonging to that module.
// Payload is untrusted: type-guard before using a field as a param.
export const questionnaireReady: NotificationRenderer = {
  icon: FileUp,
  accent: "default",
  title: (payload) =>
    typeof payload?.filename === "string"
      ? { key: "NOTIF/QUESTIONNAIRE_READY/TITLE", params: { filename: payload.filename } }
      : { key: "NOTIF/QUESTIONNAIRE_READY/TITLE_GENERIC" },
  description: () => ({ key: "NOTIF/QUESTIONNAIRE_READY/DESC" }),
  cta: "NOTIF/CTA/OPEN_QUESTIONNAIRE",
  onAction: navigateForAction,
}
